import { getJoinableSiteLinks, type JoinableSiteItemType } from './cross-join-links';
import { isComplete, isError } from '../../common/providers/as-data-provider';
import { type ProviderResults } from '../../types';

export function collectJoinableSiteLinks(
	joinableSites: ProviderResults['joinableSites'],
	productConfiguration: ProviderResults['productConfiguration'],
): JoinableSiteItemType[] | undefined {
	if (joinableSites === undefined || isError(joinableSites)) {
		return [];
	}

	if (isComplete(joinableSites) && isComplete(productConfiguration)) {
		const joinableSiteLinks = getJoinableSiteLinks(
			joinableSites.data.sites,
			productConfiguration.data.products,
		);

		// Rebranding Rules:
		// 1. When both Jira Work Management (JWM) and Jira Software (JSW) appear, rebrand both and only show one link
		// 2. When only one of them (JWM or JSW) appears, rebrand both
		// for more info: https://hello.atlassian.net/wiki/spaces/Spork/pages/4059534637/Spork+Rebranding+Appswitcher+behaviour

		// check if JWM needed
		const shouldRemoveJWM = joinableSiteLinks.some(
			({ productType }) =>
				productType &&
				['JIRA_SOFTWARE', 'JIRA_PRODUCT_DISCOVERY', 'JIRA_SERVICE_DESK'].includes(productType),
		);

		// remove JWM
		const filteredJoinableSiteLinks = joinableSiteLinks.filter(
			(p) => !(p.productType === 'JIRA_BUSINESS' && shouldRemoveJWM),
		);

		// rebrand JSW and/or JWM
		for (const joinableSiteLink of filteredJoinableSiteLinks) {
			const productConfig =
				joinableSiteLink.productType &&
				productConfiguration.data.products[joinableSiteLink.productType];

			if (
				(joinableSiteLink.productType === 'JIRA_SOFTWARE' ||
					joinableSiteLink.productType === 'JIRA_BUSINESS') &&
				productConfig
			) {
				joinableSiteLink.iconKey = productConfig.rebrandedIconKey ?? joinableSiteLink.iconKey;
				joinableSiteLink.label = productConfig.rebrandedLabel ?? joinableSiteLink.label;
			}
		}

		return filteredJoinableSiteLinks;
	}
}
